import { Step } from 'signup-constants/Step';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { setFlow } from '../../store/flow/action-creators';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { Tracker } from '../../store/tracking/action-creators';
import { ExperimentKeys } from '../ExperimentKeys';
import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
const ACQ145MappedLoadingKeys = new Map([[LoadingKey.SignupRequest, LoadingKey.ACQ145SignupRequest], [LoadingKey.LoginAfterSignup, LoadingKey.ACQ145PortalCreated]]);
export const getACQ145EndpointLoadingKey = (state, loadingKey) => {
  const parameter = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0145, [ExperimentParameterGroup.Variant_A]);
  if (parameter && loadingKey && ACQ145MappedLoadingKeys.has(loadingKey)) return ACQ145MappedLoadingKeys.get(loadingKey);
  return loadingKey;
};
export const setFlowForACQ145 = ({
  stepsToRemove = [],
  isPreVerificationExistingUserSession = false
}) => dispatch => {
  const {
    postExistingAccountSelection: acq145VariantAPostExistingAccountSelectionSteps
  } = getFlowSteps();
  const acq145VariantAPreVerificationSteps = [Step.LandingPage, Step.CodeVerification];
  const acq145VariantAPostAccountCreationSteps = [Step.UseCase];
  const acq145VariantAPostVerificationSteps = [Step.Password, Step.Name, Step.Industry, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection];
  const acq145NextSteps = [...(isPreVerificationExistingUserSession ? [Step.ExistingUser] : []), ...(isPreVerification() ? acq145VariantAPreVerificationSteps : []), ...acq145VariantAPostVerificationSteps, ...acq145VariantAPostAccountCreationSteps];
  const acq145FlowSteps = {
    acq145NextSteps,
    acq145VariantAPreVerificationSteps,
    acq145VariantAPostVerificationSteps,
    acq145VariantAPostAccountCreationSteps,
    acq145VariantAPostExistingAccountSelectionSteps
  };
  if (stepsToRemove.length > 0) {
    // replicating the logic inside FlowStateManager.removeSteps(stepsToRemove)
    Object.keys(acq145FlowSteps).forEach(key => {
      acq145FlowSteps[key] = NextStepManager.removeSteps(...stepsToRemove)(acq145FlowSteps[key]);
    });
  }
  dispatch(setFlow(acq145FlowSteps.acq145NextSteps, acq145FlowSteps.acq145VariantAPreVerificationSteps, acq145FlowSteps.acq145VariantAPostVerificationSteps, acq145FlowSteps.acq145VariantAPostAccountCreationSteps, acq145FlowSteps.acq145VariantAPostExistingAccountSelectionSteps));
  return acq145NextSteps;
};
export const setupAuthForOAuthExistingUserACQ145 = (state, experimentKey, dispatch) => {
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-variant_a`));
  dispatch(setFlowForACQ145({
    isPreVerificationExistingUserSession: getIsAuthenticated(state) && isPreVerification()
  }));
};